export default __webpack_public_path__ + "static/media/flag-saint-pierre-and-miquelon.0f460086.svg";